import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RenderIn, device } from '../../utils/RenderIn';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import styles from './HpRespModuleContainerOld.scss';

function HpRespModuleHeader({ children }) {
    return children ? (
        <Fragment>
            <RenderIn deviceTypes={[device.DESKTOP, device.TABLET]}>
                <BarHeader title={children} size="xLarge" htmlElementType="h2" />
            </RenderIn>
            <RenderIn deviceTypes={[device.MOBILE]}>
                <BarHeader title={children} htmlElementType="h2" />
            </RenderIn>
        </Fragment>
    ) : null;
}

HpRespModuleHeader.propTypes = {
    children: PropTypes.node,
};

function HpRespModuleSubHeader({ children }) {
    return children ? <h2 className={styles.subHeader}>{children}</h2> : null;
}

HpRespModuleSubHeader.propTypes = {
    children: PropTypes.node,
};

class HpRespModuleContainerOld extends Component {
    static Header = HpRespModuleHeader;

    static SubHeader = HpRespModuleSubHeader;

    render() {
        return (
            <div
                data-tn={this.props.dataTn}
                className={classnames(
                    { [styles.addTopGap]: this.props.addTopGap },
                    this.props.className
                )}
            >
                {this.props.children}
            </div>
        );
    }
}

HpRespModuleContainerOld.propTypes = {
    children: PropTypes.node,
    addTopGap: PropTypes.bool,
    className: PropTypes.string,
    dataTn: PropTypes.string,
};

HpRespModuleContainerOld.defaultProp = {
    addTopGap: false,
    className: null,
    dataTn: '',
};

export { HpRespModuleContainerOld };
